import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import HeaderWithSearch from '../components/HeaderWithSearch'
import HorizontalEventMenu from '../components/HorizontalEventMenu'
import Time from '../components/Time'
import EventContent from '../components/EventContent'
import { Query } from 'react-apollo'
import { OFFENSE_OF_CURRENT_DAY } from '../query/event'
import CircularProgress from '@material-ui/core/CircularProgress'
import {
  getTrackableIds,
  getFleetById
} from '../utils/trackable'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getProduct
} from '../utils/helper'

class Offense extends React.Component {
  constructor (props) {
    super(props)
    this._isMounted = false
    this.state = {
      loading: true,
      keySearch: null
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var product = this.props.match.params.product_id
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(async function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token')).then(function () {
              var newToken = localStorage.getItem('token')
              getUserInfo(newToken)
                .then(response => response.json())
                .then(async function (data) {
                  var products = data.data.attributes.products.fuel_sensor
                  if (getProduct(products, product).length > 0) {
                    var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
                    var fleet = await getFleetById(fleetId)
                    if (fleet) {
                      localStorage.setItem('endpoint', product)
                      let trackables = fleet.trackables
                      let fleetName = fleet.name
                      localStorage.setItem('fleetName', fleetName)
                      self.setState({
                        loading: false,
                        trackables: trackables
                      })
                    } else document.location.href = '/#/error'
                  } else document.location.href = '/#/error'
                })
                .catch((error) => {
                  console.log('error: ', error)
                })
            })
          } else {
            var products = data.data.attributes.products.fuel_sensor
            if (getProduct(products, product).length > 0) {
              var fleetId = getProduct(products, product)[0].fleets_track_settings[0].fleet_id
              var fleet = await getFleetById(fleetId)
              if (fleet) {
                localStorage.setItem('endpoint', product)
                let trackables = fleet.trackables
                let fleetName = fleet.name
                localStorage.setItem('fleetName', fleetName)
                self.setState({
                  loading: false,
                  trackables: trackables
                })
              } else document.location.href = '/#/error'
            } else document.location.href = '/#/error'
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  render () {
    let d = new Date()
    d.setHours(0, 0, 0, 0)
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu
                  enabled='event'
                />
              </td>
              <td style={styles.content}>
                <HeaderWithSearch
                  title='Evenements'
                  getKeySearch={(key) => this.setState({ keySearch: key })}
                />
                <HorizontalEventMenu
                  enabled='offense'
                />
                {this.state.loading ? <CircularProgress
                  style={styles.progressStyle}
                  color='inherit'
                /> : <Query
                  query={OFFENSE_OF_CURRENT_DAY}
                  variables={{ occurred_at: d, trackable_ids: getTrackableIds(this.state.trackables) }}
                >
                  {({ data, loading, error, subscribeToMore }) => {
                    if (!data) {
                      return null
                    }
                    if (error) {
                      return <p>{error.message}</p>
                    }

                    if (loading) {
                      return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
                    }

                    return (
                      <EventContent
                        route='Offense'
                        events={data.events}
                        trackables={this.state.trackables}
                        subscribeToMore={subscribeToMore}
                        keySearch={this.state.keySearch}
                      />
                    )
                  }}
                </Query>
                }
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  progressStyle: {
    marginTop: '50px',
    color: '#7ED321'
  }
}

export default Offense
